/* eslint-disable import/prefer-default-export,react/jsx-props-no-spreading,jsx-a11y/alt-text */
import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { dynamicAssets } from '../../utilities/helpers';
import { GenericLoading } from '../Placeholders';

export const ImageWithLoader = forwardRef(({ src, ...props }, ref) => {
  const [loading, setLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    let loadImageTimeout;

    const img = new Image();
    img.src = dynamicAssets(src);

    img.onload = () => {
      setImageSrc(img.src);
      loadImageTimeout = setTimeout(() => {
        setLoading(false);
      }, 300);
    };

    img.onerror = () => {
      setLoading(false);
    };

    return () => {
      if (loadImageTimeout) {
        clearTimeout(loadImageTimeout);
      }
    };
  }, [src]);

  if (loading) {
    return <GenericLoading isFullScreen customSize="4rem" customSpacing="my-3" />;
  }

  return <img ref={ref} {...props} src={imageSrc || ''} />;
});

ImageWithLoader.displayName = 'ImageWithLoader';

ImageWithLoader.propTypes = {
  src: PropTypes.string.isRequired,
};
